import { ComponentProps } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Button } from '@zep/ui';
import { StoreBannerItem } from './types';
interface StoreBannerButtonProps {
  bannerData: StoreBannerItem;
}
export const StoreBannerButton = ({
  bannerData
}: StoreBannerButtonProps) => {
  const {
    buttonLabel,
    buttonColor
  } = bannerData;
  const isMobile = useMediaQuery({
    query: `(max-width: 679px)`
  });
  const size: ComponentProps<typeof Button>['size'] = isMobile ? 'xxs' : 'xs';
  return <Button size={size} style={{
    backgroundColor: buttonColor || '#0D94FF'
  }} data-sentry-element="Button" data-sentry-component="StoreBannerButton" data-sentry-source-file="StoreBannerButton.tsx">
      {buttonLabel}
    </Button>;
};